/** Bank-transfer details for the business an order belongs to (probound / proepoxy / protraining / oxresin). */
import React, { useEffect, useState } from 'react';
import { Landmark } from 'lucide-react';
import API_URL from '@/config/api';

let cache = null;
export async function loadBankDetails() {
  if (cache) return cache;
  const r = await fetch(`${API_URL}/api/bank-details`, { credentials: 'include' });
  if (!r.ok) throw new Error('Could not load bank details');
  cache = (await r.json()).details || {};
  return cache;
}
export const resetBankDetailsCache = () => { cache = null; };

export function BankDetails({ business, reference, compact = false, testId }) {
  const [d, setD] = useState(null);
  useEffect(() => { loadBankDetails().then((all) => setD(all[business] || null)).catch(() => setD(null)); }, [business]);
  if (!d || !d.account_number || !d.sort_code) return null;
  return (
    <div className={`rounded-lg border border-slate-200 bg-white ${compact ? 'px-3 py-2 text-xs' : 'p-3 text-sm'} text-slate-800`} data-testid={testId || `bank-details-${business}`}>
      <div className="font-bold inline-flex items-center gap-1.5 text-slate-900"><Landmark className="w-3.5 h-3.5" /> Pay by bank transfer</div>
      <dl className="mt-1 grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5">
        {d.account_name && <><dt className="text-slate-500">Account name</dt><dd className="font-semibold">{d.account_name}</dd></>}
        <dt className="text-slate-500">Account number</dt><dd className="font-semibold tabular-nums" data-testid={`${testId || `bank-details-${business}`}-acc`}>{d.account_number}</dd>
        <dt className="text-slate-500">Sort code</dt><dd className="font-semibold tabular-nums" data-testid={`${testId || `bank-details-${business}`}-sort`}>{d.sort_code}</dd>
        {reference && <><dt className="text-slate-500">Reference</dt><dd className="font-semibold">{reference}</dd></>}
      </dl>
      {d.note && <p className="mt-1 text-[11px] text-slate-500">{d.note}</p>}
    </div>
  );
}
